import "./ServicesPreview.css";
// import { Link } from "react-router-dom";

import servicesData from "../../data/servicesData";
import ServiceCard from "../ServiceCard/ServiceCard";

const ServicesPreview = () => {
  const featuredServices = servicesData.filter((service) => service.featured);

  return (
    <section className="services-preview" id="services">
      {/* ================= HEADER ================= */}
      <div className="services-header">
        <span className="section-tag1">OUR SERVICES</span>

        <h2>Complete Sports Infrastructure Solutions</h2>

        <p>
          We specialize in designing and constructing world-class sports
          infrastructure for schools, universities, government organizations,
          clubs, builders and sports academies across India.
        </p>
      </div>

      {/* ================= SERVICES ================= */}
      <div className="services-grid">
        {featuredServices.map((service) => (
          <ServiceCard key={service.id} service={service} />
        ))}

        {/* MORE SERVICES
        <Link
          to="/services"
          className="more-services-card"
        >
          <div className="more-number">
            20+
          </div>

          <h3>
            Sports Infrastructure
            <br />
            Solutions
          </h3>

          <p>
            Explore every service we provide.
          </p>

          <span>
            View All Services →
          </span>
        </Link> */}
      </div>
    </section>
  );
};

export default ServicesPreview;
